import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { dash_case, smoothScroll, requestIdleCallback, cancelIdleCallback } from 'Common/Utils';
import { SmoothScroll, useScrollSpy } from 'Snippets/Animation';
const ScrollNavProps = {
	list: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string.isRequired,
			sub: PropTypes.arrayOf(
				PropTypes.shape({
					label: PropTypes.string.isRequired,
				})
			),
		})
	).isRequired,
	url: PropTypes.string,
};

export const ScrollNav = ({ list, url = '' }) => {
	const prefixTop = 110;
	useEffect(() => {
		const { hash } = window.location;
		if (!hash) return;
		const cleanup = requestIdleCallback(() => {
			document.body.style.willChange = 'scroll-position';
			const animate = smoothScroll(hash.substr(1), prefixTop);
			if (animate) {
				const f = (ev) => {
					ev.preventDefault();
				};
				const passive = { passive: false };
				window.addEventListener('mousewheel', f, passive);
				animate.done = () => {
					window.removeEventListener('mousewheel', f, passive);
					document.body.style.willChange = null;
				};
			}
		});
		return () => cancelIdleCallback(cleanup);
	}, [prefixTop]);

	const scrollSpyRegistry = flattenList(list);

	useScrollSpy(scrollSpyRegistry, url, '.side-panel', prefixTop);

	return <Mapper list={list} url={url} />;
};

ScrollNav.propTypes = ScrollNavProps;

const Mapper = ({ list, url }) => (
	<ul className='scroll-nav n-border-color'>
		{list.map(({ label, sub }) => (
			<li key={label}>
				<SmoothScroll
					href={`${url}#${dash_case(label.toLowerCase())}`}
					label={label}
					className="n-text-dim-color n-text-hover"
				/>
				{sub && <Mapper list={sub} url={url} />}
			</li>
		))}
	</ul>
);

const flattenList = (list, reloop) =>
	list.reduce((result, { label, sub }) => {
		result.push(dash_case(label.toLowerCase()));
		return sub ? flattenList(sub, result) : result;
	}, reloop || []);
